import React from 'react'
import { MDBInput, MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEnvelope, faClipboardList, faCloudDownloadAlt, faTimes, faPrint, faTruck } from '@fortawesome/free-solid-svg-icons'
import HeaderTabla from '../componentes/HeaderTabla'

const tipoCanal = (canal) => canal === "Facturación" ? "Tienda Física" : canal === "Tienda" ? "Página web" : canal === "Activacion" ? "Activaciones" : "App"
const VerPedidos = ({ dataFiltrado, SeleccionarPedido }) => {

    const formatoSeparador = (number) => {
        const exp = /(\d)(?=(\d{3})+(?!\d))/g;
        const rep = '$1,';
        return `$${number.toString().replace(exp, rep)}`;
    }

    return (
        <div>
            <MDBTable hover responsive >
                <HeaderTabla array={['ID', 'Fecha', 'estado', 'Cliente', 'Total', 'Imp', 'Pedido', 'Tipo', '']} />
                <MDBTableBody>


                    {dataFiltrado.map((item, index) => {
                        if (item.pedido.length > 0) {
                            return (
                                <tr key={index}>
                                    <td>BLUE-{item.id}</td>
                                    <td>{item.fecha}</td>
                                    <td><div className={`estados ${item.estado}`}>{item.estado}</div></td>
                                    <td>{item.cliente.nombre}</td>
                                    <td>{formatoSeparador(item.datosPago.total)}</td>
                                    <td>{item.datosPago.taxes}</td>
                                    <td>{`${item.pedido[0].nombre_producto} ...`}</td>
                                    <td>{tipoCanal(item.canal)}</td>
                                    <td className="tabla_unica">
                                        <div className="col text-center d-flex">

                                            <button
                                                onClick={SeleccionarPedido(item, 'pedido')}
                                                className="btn boton_estandar_blanco"
                                            ><FontAwesomeIcon icon={faEye} size="lg" />
                                            </button>

                                            <button
                                                onClick={SeleccionarPedido(item, 'seguimiento')}
                                                className="btn boton_estandar_blanco"
                                            ><FontAwesomeIcon icon={faTruck} size="lg" />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            )
                        }

                    })
                    }

                </MDBTableBody>
            </MDBTable>


        </div>
    )
}

export default VerPedidos